window.middysHawkSearchTemplates = window.middysHawkSearchTemplates || {};
window.middysHawkSearchTemplates.checkboxListFacet = `
    <style>
        ul.parent-category {
            padding-left: 0;
            max-height: 490px;
            overflow: hidden;
            overflow-y: auto;
        }

        ul {
            display: none;
            padding-left: 18px;
            margin: 10px 0;
            list-style-type: none;
        }

        ul li {
            position: relative;
            margin-bottom: 20px;
        }

        .product-filters .filter-block input[type=checkbox]:checked+label {
            font-weight: 600;
        }

        input[type=checkbox]:checked+label {
            transition: all .3s ease;
            background: url(/images/checkbox-selected.svg) no-repeat left top;
        }

        input[type=checkbox]+label {
            font-family: Lato;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            min-height: 18px;
            display: inline-block;
            letter-spacing: .02em;
            color: #464343;
            padding-left: 30px;
            background: url(/images/checkbox-unselected.svg) no-repeat left top;
            transition: all .3s ease;
        }

        input[type=checkbox]:checked+label {
            font-weight: 600;
        }

        :host, :root {
            --color-accent: '';
            --color-background: '';
            --form-element-border: '';
        }
    </style>
    <div style="{{#if maxHeight}}max-height: {{maxHeight}}px;{{/if}}">
        {{> facet-checkbox-list values}}
    </div>
`;
